
import { controls } from '~/mixins/carousel'
import { selector } from '~/mixins/selector'

export default {
  mixins: [controls, selector],
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },

  watch: {
    activeDot: {
      handler(next) {
        this.$gsap.to(this.selector('.mask'), {
          background: this.blok.tabs[next]?.overlay_color,
          duration: 0.5,
        })
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    init() {
      if (this.selector) {
        this.$gsap.to(this.selector('.mask'), {
          background: this.blok.tabs[0]?.overlay_color,
          duration: 0.5,
        })
      }
    },
  },
}
